import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SapAccountGroupService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  SapAccountGroupCreateDto,
  SapAccountGroupDto,
  SapAccountGroupExcelDownloadDto,
  SapAccountGroupUpdateDto,
} from '../proxy/controlling/dtos/sap-account-group';
import { SAPACCOUNTGROUP_CONFIG, SAPACCOUNTGROUP_FIELDS } from './sap-account-group.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-sap-account-group',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, SapAccountGroupService, ConfirmationService],
  templateUrl: './sap-account-group.html',
  styleUrl: './sap-account-group.scss',
})
export class SapAccountGroup extends BaseHierarchicalCrudComponent<
  SapAccountGroupDto,
  SapAccountGroupCreateDto,
  SapAccountGroupUpdateDto,
  SapAccountGroupExcelDownloadDto
> {
  service = inject(SapAccountGroupService);
  config = SAPACCOUNTGROUP_CONFIG;
  fields = SAPACCOUNTGROUP_FIELDS;

  protected prepareUpdateDto(data: any, selected: SapAccountGroupDto): SapAccountGroupUpdateDto {
    return {
      ...data,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'SapAccountGroup';
  }
}
